const getSearchParams = () => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  return Object.fromEntries(params);
};

export default getSearchParams;
